import { type Page } from '../cpc/constants';
import createErrors from '../createErrors';

export type Component = 'PromoCodeForm';

/**
 * Errors related to the Treats Rewards page
 */
export const Errors = createErrors<Page, Component>('Cart')({
    PromoCodeForm: {
        PromoCodeInvalid: {
            severity: 'MEDIUM',
            message: 'Promo code is invalid or expired',
        },
        AddPromoFailed: {
            severity: 'MEDIUM',
            message: 'Failed to apply promo code',
        },
        RemovePromoFailed: {
            severity: 'MEDIUM',
            message: 'Failed to remove discount code',
        },
    },
});
